import styled, { css } from "styled-components";
import tvgConf from "@tvg/conf";
import { isSafari } from "@tvg/utils/mobileUtils";
import {
  fontCondensedNormal,
  fontMedium,
  fontNormal
} from "../../_static/Typography";
import buildColor from "../../_static/ColorPalette";

export const DetailsWrapper = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  ${({ wrapperMarginBottom }) => `margin-bottom: ${wrapperMarginBottom}px;`}
  ${({ hasBorderTop }) =>
    hasBorderTop
      ? css`
          border-top: 1px solid ${buildColor("blue", "100")};
          padding-top: 22px;
        `
      : ""};
  ${({ hasBorderBottom }) =>
    hasBorderBottom
      ? css`
          border-bottom: 1px solid ${buildColor("blue", "100")};
        `
      : ""};
`;

export const DetailsLine = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  ${({ marginBottom }) => `margin-bottom: ${marginBottom}px;`}
`;

export const TextWrapper = styled.div`
  display: flex;
  align-items: center;

  svg {
    margin-right: 4px;
  }
`;

export const InnerTextVertical = styled.div`
  display: flex;
  flex-direction: column;
`;

export const InnerTextWrapper = styled.div`
  display: flex;
`;

export const DetailsTitle = styled.h2`
  font-family: ${fontMedium};
  font-weight: 500;
  font-size: 14px;
  color: ${buildColor("grey", "900")};
`;

export const DetailsOptional = styled.p`
  padding-left: 4px;
  font-family: ${fontNormal};
  font-weight: 400;
  font-size: 14px;
  color: ${buildColor("grey", "700")};
`;

export const DetailsText = styled.p`
  font-family: ${fontNormal};
  font-weight: 400;
  font-size: 14px;
  color: ${buildColor("grey", "800")};
  display: flex;
  align-items: center;
  ${({ isPassword }) =>
    isPassword &&
    css`
      -webkit-text-security: disc;
      letter-spacing: 3.2px;
      color: ${buildColor("grey", "900")};
    `};
`;

const isIos =
  tvgConf().product === "ios2" ||
  tvgConf().product === "iosnative" ||
  (typeof window !== "undefined" &&
    /^((?!chrome|android).)*safari/i.test(navigator.userAgent));

export const DetailsPassword = styled.input`
  width: ${() => (isIos ? "33px" : "32px")};
  font-family: ${fontNormal};
  font-weight: 400;
  font-size: 14px;
  color: ${buildColor("grey", "900")};
  display: flex;
  align-items: center;
  background-color: transparent;
  opacity: 1;
  ${({ isPasswordVisible }) =>
    !isPasswordVisible &&
    css`
      letter-spacing: ${() => (isIos ? "0" : "3.2px")};
      color: ${buildColor("grey", "900")};
    `};
`;

export const LowerText = styled.p`
  font-family: ${fontCondensedNormal};
  font-weight: 400;
  font-size: 12px;
  color: ${buildColor("grey", "600")};
`;

export const CustomEditButton = styled.button`
  font-family: ${fontMedium};
  font-weight: 500;
  font-size: 14px;
  color: ${buildColor("blue_accent", "500")};
  cursor: pointer;
  background-color: transparent;
  outline: none;
`;

export const PasswordWrapper = styled.div`
  display: flex;

  button {
    margin-left: 8px;
  }
`;

export const IconWrapper = styled.span`
  flex-shrink: 0;
  display: inline-flex;
`;

export const IconButton = styled.button`
  cursor: pointer;
  background-color: transparent;
  outline: none;
  height: 24px;
  width: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    background-color: ${buildColor("blue_accent", "100")};
    border-radius: 50%;
  }
`;
